module.exports = __webpack_public_path__ + "img/59.437098eb.png";